<template>
  <div :class="'modal_big community_modal' + (isShowing ? ' show' : '')" style="overflow-y: hidden">
    <div class="community_modal_inner">
      <div class="community_modal_background" />
      <div class="community_modal_container w700">
        <div
          class="community_modal_close close_modal"
          data-modal="modal_video_clip_embed"
          @click="close()"
        >
          <i class="sp-ic-sm-modal-close sp-ic-sm-modal-close-14x14" />
        </div>
        <div class="hub_clip_embed_container">
          <iframe
            id="video_clip_embed_frame"
            :src="videoUrl"
            width="640"
            height="360"
            frameborder="0"
            scrolling="no"
            allowfullscreen="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { component } from '../../mixins/component';
import { EventBus, SHOW_VIDEO_CLIP_EMBED, VIDEO_CLIP_EMBED_HIDE } from '../../event-bus';
import { ConfigMixin } from '../../mixins/config';
import Modal from './Modal';

export default {
  extends: Modal,
  mixins: [component, ConfigMixin],
  data() {
    return {
      videoUrl: '',
    };
  },
  mounted() {
    EventBus.$on(SHOW_VIDEO_CLIP_EMBED, (url, domain) => {
      this.show();
      this.videoUrl = url + '&parent=' + (domain || window.location.host);
    });
  },
  beforeDestroy() {
    EventBus.$off(SHOW_VIDEO_CLIP_EMBED);
  },
  methods: {
    close() {
      this.hide();
      this.videoUrl = '';
      EventBus.$emit(VIDEO_CLIP_EMBED_HIDE);
    },
  },
};
</script>

<style scoped>
#video_clip_embed_frame {
  max-width: 100%;
}
</style>
